import React, { useState } from "react";
import "./Contact.css";

const Contact = ({ title, fields, button, image }) => {
  const [formData, setFormData] = useState(
    fields.reduce((acc, field) => {
      acc[field.name] = "";
      return acc;
    }, {})
  );

  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Submitting...");

    try {
      const response = await fetch("https://aspwppl-backend.vercel.app/form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("Message sent successfully!");
        setFormData(fields.reduce((acc, field) => {
          acc[field.name] = "";
          return acc;
        }, {}));
      } else {
        setStatus("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setStatus("Server error. Please try later.");
    }
  };

  return (
    <div
      className="contact-container"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="contact-form-box">
        <h2 className="contact-title">{title}</h2>

        <form className="contact-form" onSubmit={handleSubmit}>
          {fields.map((field, index) =>
            field.type === "textarea" ? (
              <textarea
                key={index}
                name={field.name}
                placeholder={field.placeholder}
                rows="4"
                required={field.required}
                value={formData[field.name]}
                onChange={handleChange}
                className="contact-textarea"
              />
            ) : (
              <input
                key={index}
                type={field.type}
                name={field.name}
                placeholder={field.placeholder}
                required={field.required}
                value={formData[field.name]}
                onChange={handleChange}
                className="contact-input"
              />
            )
          )}

          <button type="submit" className="contact-submit-button">
            {button}
          </button>

          {status && <p className="contact-status">{status}</p>}
        </form>
      </div>
    </div>
  );
};

export default Contact;
